import React, { useState, useEffect, useCallback } from "react";
import swal from "sweetalert";
import { producaov2 } from "../../../services/apis";
import {
  CPFWrapper,
  Container,
  DocumentsItem,
  DocumentsWrapper,
  Input,
  Select,
  Button,
  UploadWrapper,
} from "./styles";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import { AlunoSearchInput } from "../../../components/Admin/AlunoSearchInput";
import { convertDate } from "../../../utils/Utils";

// Mesmos fieldnames aceitos por PUT /admin/mba/documents/:user_id
const TIPOS_DOCUMENTO = [
  { value: "rg_frente", label: "RG (frente)" },
  { value: "rg_verso", label: "RG (verso)" },
  { value: "cpf_frente", label: "CPF (frente)" },
  { value: "cpf_verso", label: "CPF (verso)" },
  { value: "diploma_frente", label: "Diploma de ensino superior (frente)" },
  { value: "diploma_verso", label: "Diploma de ensino superior (verso)" },
  { value: "titulo_eleitor_frente", label: "Título de eleitor (frente)" },
  { value: "titulo_eleitor_verso", label: "Título de eleitor (verso)" },
  { value: "comprovante_residencia_frente", label: "Comprovante de residência (frente)" },
  { value: "comprovante_residencia_verso", label: "Comprovante de residência (verso)" },
  { value: "certidao_registro_civil_frente", label: "Certidão de registro civil (frente)" },
  { value: "certidao_registro_civil_verso", label: "Certidão de registro civil (verso)" },
  { value: "certificado_reservista_frente", label: "Certificado de reservista (frente)" },
  { value: "certificado_reservista_verso", label: "Certificado de reservista (verso)" },
];

export const MBADocumentos = props => {
  const [selectedAluno, setSelectedAluno] = useState(null);
  const [documents, setDocuments] = useState(null);
  const [tipoUpload, setTipoUpload] = useState(TIPOS_DOCUMENTO[0].value);
  const [arquivoUpload, setArquivoUpload] = useState(null);
  const [enviando, setEnviando] = useState(false);

  const handleDownload = (data, filename, id) => {
    const a = document.getElementById(id);

    if (!a) {
      console.error(`Elemento com id ${id} não encontrado`);
      return;
    }

    if (!data) {
      a.style.display = "none";
      return;
    }

    const blob = new Blob([data]);
    const blobUrl = URL.createObjectURL(blob);

    a.href = blobUrl;
    a.download = filename;
  };

  const carregarDocumentos = useCallback(() => {
    if (!selectedAluno) return;
    producaov2
      .get(`/admin/mba/documents/${selectedAluno}`)
      .then(response => setDocuments(response.data))
      .catch(err => {
        if (err?.response?.data?.message === "Registros não encontrados") {
          swal("Nenhum documento foi encontrado", "", "error");
        }
      });
  }, [selectedAluno]);

  useEffect(() => {
    carregarDocumentos();
  }, [carregarDocumentos]);

  // Sobe o documento em nome do aluno: é o caminho para o que chega por
  // WhatsApp ou e-mail, que antes ficava fora do cadastro.
  const enviarDocumento = async evt => {
    evt.preventDefault();
    // React 16 recicla o evento sintético depois do await: guardar o form agora,
    // senão evt.target vira null e o erro cai no catch com o upload já feito.
    const form = evt.target;
    if (!selectedAluno) {
      swal("Selecione o aluno antes de enviar", "", "error");
      return;
    }
    if (!arquivoUpload) {
      swal("Escolha o arquivo", "", "error");
      return;
    }
    const formData = new FormData();
    formData.append(tipoUpload, arquivoUpload);
    setEnviando(true);
    try {
      await producaov2.put(`/admin/mba/documents/${selectedAluno}`, formData);
    } catch (err) {
      setEnviando(false);
      swal("Não foi possível enviar", err?.response?.data?.message || "Tente novamente.", "error");
      return;
    }
    // daqui para baixo o documento já está no cadastro: nada pode virar "não foi possível"
    setEnviando(false);
    setArquivoUpload(null);
    if (form && form.reset) form.reset();
    carregarDocumentos();
    swal("Documento enviado", "O aluno deixa de constar pendente nesse item.", "success");
  };

  useEffect(() => {
    if (!documents) return;
    const files = [
      {
        path: documents.diploma_frente_path,
        name: documents.diploma_frente_filename,
        id: "diploma_frente",
      },
      {
        path: documents.diploma_verso_path,
        name: documents.diploma_verso_filename,
        id: "diploma_verso",
      },
      {
        path: documents.comprovante_residencia_frente_path,
        name: documents.comprovante_residencia_frente_filename,
        id: "comprovante_de_residencia_frente",
      },
      {
        path: documents.comprovante_residencia_verso_path,
        name: documents.comprovante_residencia_verso_filename,
        id: "comprovante_de_residencia_verso",
      },
      {
        path: documents.cpf_frente_path,
        name: documents.cpf_frente_filename,
        id: "cpf_frente",
      },
      {
        path: documents.cpf_verso_path,
        name: documents.cpf_verso_filename,
        id: "cpf_verso",
      },
      {
        path: documents.rg_frente_path,
        name: documents.rg_frente_filename,
        id: "rg_frente",
      },
      {
        path: documents.rg_verso_path,
        name: documents.rg_verso_filename,
        id: "rg_verso",
      },
      {
        path: documents.certidao_registro_civil_frente_path,
        name: documents.certidao_registro_civil_frente_filename,
        id: "certidao_registro_civil_frente",
      },
      {
        path: documents.certidao_registro_civil_verso_path,
        name: documents.certidao_registro_civil_verso_filename,
        id: "certidao_registro_civil_verso",
      },
      {
        path: documents.titulo_eleitor_frente_path,
        name: documents.titulo_eleitor_frente_filename,
        id: "titulo_eleitor_frente",
      },
      {
        path: documents.titulo_eleitor_verso_path,
        name: documents.titulo_eleitor_verso_filename,
        id: "titulo_eleitor_verso",
      },
      {
        path: documents.certificado_reservista_frente_path,
        name: documents.certificado_reservista_frente_filename,
        id: "certificado_reservista_frente",
      },
      {
        path: documents.certificado_reservista_verso_path,
        name: documents.certificado_reservista_verso_filename,
        id: "certificado_reservista_verso",
      },
    ];

    files.forEach(async file => {
      if (!file.path || !file.name) {
        handleDownload(null, null, file.id);
        return;
      }

      const mbaIdx = file.path.indexOf("mba/");
      if (mbaIdx < 0) {
        handleDownload(null, null, file.id);
        return;
      }
      const key = file.path.slice(mbaIdx);

      try {
        const response = await producaov2.get("/admin/mba/documents/download", {
          params: { path: key },
          responseType: "arraybuffer",
        });
        handleDownload(response.data, file.name, file.id);
      } catch (err) {
        handleDownload(null, null, file.id);
      }
    });
  }, [documents]);

  return (
    <div style={{width: "100vw", paddingLeft:"250px"}}>

      <AdminMenu />
      <Container>
        <h1>Acessar documentos MBA</h1>

        <form>
          <label>Selecione o aluno</label>
          <AlunoSearchInput
            handleChange={evt => {
              setSelectedAluno(evt.id);
            }}
            hideLabel={true}
            clearableOnSelect={true}
          />

          {documents && (
            <DocumentsWrapper>
            
              <h2>Documentos enviados:</h2>

              <CPFWrapper>
                <span>
                  <p>CPF: </p>
                  <Input
                    value={documents.pessoa.cpf}
                    placeholder={documents.pessoa.cpf}
                    disabled
                  />
                </span>

                <span>
                  <p>Data Emissão RG: </p>
                  <Input
                    value={convertDate(documents.data_emissao_rg)}
                    placeholder={convertDate(documents.data_emissao_rg)}
                    disabled
                  />
                </span>
              </CPFWrapper>

              <DocumentsItem>
                <p>Estado civil:</p>

                {documents.estado_civil ? (
                  <span className="last__child">
                    <Input
                      value={documents.estado_civil}
                      placeholder={documents.estado_civil}
                      disabled
                    />
                  </span>
                ) : (
                  <span>Não enviado</span>
                )}
              </DocumentsItem>

              <DocumentsItem>
                <p>Diploma de ensino superior (Frente):</p>

                {documents.diploma_frente_path ? (
                  <span>
                    <Input
                      value={documents.diploma_frente_filename}
                      placeholder={documents.diploma_frente_filename}
                      disabled
                    />
                    <a id="diploma_frente">Baixar arquivo</a>
                  </span>
                ) : (
                  <span>Não enviado</span>
                )}
              </DocumentsItem>

              <DocumentsItem>
                <p>Diploma de ensino superior (Verso):</p>

                {documents.diploma_verso_path ? (
                  <span>
                    <Input
                      value={documents.diploma_verso_filename}
                      placeholder={documents.diploma_verso_filename}
                      disabled
                    />
                    <a id="diploma_verso">Baixar arquivo</a>
                  </span>
                ) : (
                  <span>Não enviado</span>
                )}
              </DocumentsItem>

              <DocumentsItem>
                <p>Comprovante de residência (Frente):</p>

                {documents.comprovante_residencia_frente_path ? (
                  <span>
                    <Input
                      value={documents.comprovante_residencia_frente_filename}
                      placeholder={documents.comprovante_residencia_frente_filename}
                      disabled
                    />
                    <a id="comprovante_de_residencia_frente">Baixar arquivo</a>
                  </span>
                ) : (
                  <span>Não enviado</span>
                )}
              </DocumentsItem>

              <DocumentsItem>
                <p>Comprovante de residência (Verso):</p>

                {documents.comprovante_residencia_verso_path ? (
                  <span>
                    <Input
                      value={documents.comprovante_residencia_verso_filename}
                      placeholder={documents.comprovante_residencia_verso_filename}
                      disabled
                    />
                    <a id="comprovante_de_residencia_verso">Baixar arquivo</a>
                  </span>
                ) : (
                  <span>Não enviado</span>
                )}
              </DocumentsItem>

              <DocumentsItem>
                <p>Foto do CPF (Frente):</p>

                {documents.cpf_frente_path ? (
                  <span>
                    <Input
                      value={documents.cpf_frente_filename}
                      placeholder={documents.cpf_frente_filename}
                      disabled
                    />
                    <a id="cpf_frente">Baixar arquivo</a>
                  </span>
                ) : (
                  <span>Não enviado</span>
                )}
              </DocumentsItem>

              <DocumentsItem>
                <p>Foto do CPF (Verso):</p>

                {documents.cpf_verso_path ? (
                  <span>
                    <Input
                      value={documents.cpf_verso_filename}
                      placeholder={documents.cpf_verso_filename}
                      disabled
                    />
                    <a id="cpf_verso">Baixar arquivo</a>
                  </span>
                ) : (
                  <span>Não enviado</span>
                )}
              </DocumentsItem>

              <DocumentsItem>
                <p>Foto do RG (Frente):</p>

                {documents?.rg_frente_path ? (
                  <span>
                    <Input
                      value={documents.rg_frente_filename}
                      placeholder={documents.rg_frente_filename}
                      disabled
                    />
                    <a id="rg_frente">Baixar arquivo</a>
                  </span>
                ) : (
                  <span>Não enviado</span>
                )}
              </DocumentsItem>

              <DocumentsItem>
                <p>Foto do RG (Verso):</p>

                {documents?.rg_verso_path ? (
                  <span>
                    <Input
                      value={documents.rg_verso_filename}
                      placeholder={documents.rg_verso_filename}
                      disabled
                    />
                    <a id="rg_verso">Baixar arquivo</a>
                  </span>
                ) : (
                  <span>Não enviado</span>
                )}
              </DocumentsItem>

              <DocumentsItem>
                <p>Certidão de registro cívil (Frente):</p>

                {documents.certidao_registro_civil_frente_path ? (
                  <span>
                    <Input
                      value={documents.certidao_registro_civil_frente_filename}
                      placeholder={documents.certidao_registro_civil_frente_filename}
                      disabled
                    />
                    <a id="certidao_registro_civil_frente">Baixar arquivo</a>
                  </span>
                ) : (
                  <span>Não enviado</span>
                )}
              </DocumentsItem>

              <DocumentsItem>
                <p>Certidão de registro cívil (Verso):</p>

                {documents.certidao_registro_civil_verso_path ? (
                  <span>
                    <Input
                      value={documents.certidao_registro_civil_verso_filename}
                      placeholder={documents.certidao_registro_civil_verso_filename}
                      disabled
                    />
                    <a id="certidao_registro_civil_verso">Baixar arquivo</a>
                  </span>
                ) : (
                  <span>Não enviado</span>
                )}
              </DocumentsItem>

              <DocumentsItem>
                <p>Título de eleitor (Frente):</p>

                {documents.titulo_eleitor_frente_path ? (
                  <span>
                    <Input
                      value={documents.titulo_eleitor_frente_filename}
                      placeholder={documents.titulo_eleitor_frente_filename}
                      disabled
                    />
                    <a id="titulo_eleitor_frente">Baixar arquivo</a>
                  </span>
                ) : (
                  <span>Não enviado</span>
                )}
              </DocumentsItem>

              <DocumentsItem>
                <p>Título de eleitor (Verso):</p>

                {documents.titulo_eleitor_verso_path ? (
                  <span>
                    <Input
                      value={documents.titulo_eleitor_verso_filename}
                      placeholder={documents.titulo_eleitor_verso_filename}
                      disabled
                    />
                    <a id="titulo_eleitor_verso">Baixar arquivo</a>
                  </span>
                ) : (
                  <span>Não enviado</span>
                )}
              </DocumentsItem>

              <DocumentsItem>
                <p>Certificado de Reservista (Frente):</p>

                {documents.certificado_reservista_frente_path ? (
                  <span>
                    <Input
                      value={documents.certificado_reservista_frente_filename}
                      placeholder={documents.certificado_reservista_frente_filename}
                      disabled
                    />
                    <a id="certificado_reservista_frente">Baixar arquivo</a>
                  </span>
                ) : (
                  <span>Não enviado</span>
                )}
              </DocumentsItem>

              <DocumentsItem>
                <p>Certificado de Reservista (Verso):</p>

                {documents.certificado_reservista_verso_path ? (
                  <span>
                    <Input
                      value={documents.certificado_reservista_verso_filename}
                      placeholder={documents.certificado_reservista_verso_filename}
                      disabled
                    />
                    <a id="certificado_reservista_verso">Baixar arquivo</a>
                  </span>
                ) : (
                  <span>Não enviado</span>
                )}
              </DocumentsItem>

            </DocumentsWrapper>
          )}
        </form>

        {selectedAluno && (
          <UploadWrapper>
            <h2>Enviar documento pelo aluno</h2>
            <p>
              Para documento que chegou por WhatsApp ou e-mail. Depois de enviar,
              ele passa a constar no cadastro e sai da lista de pendências.
            </p>

            <form onSubmit={enviarDocumento}>
              <label htmlFor="tipo-documento">Tipo de documento</label>
              <Select
                id="tipo-documento"
                value={tipoUpload}
                onChange={evt => setTipoUpload(evt.target.value)}
              >
                {TIPOS_DOCUMENTO.map(tipo => (
                  <option key={tipo.value} value={tipo.value}>
                    {tipo.label}
                  </option>
                ))}
              </Select>

              <label htmlFor="arquivo-documento">Arquivo</label>
              <Input
                id="arquivo-documento"
                type="file"
                accept="image/*,application/pdf"
                onChange={evt => setArquivoUpload(evt.target.files[0] || null)}
              />

              <Button type="submit" disabled={enviando}>
                {enviando ? "Enviando..." : "Enviar documento"}
              </Button>
            </form>
          </UploadWrapper>
        )}
      </Container>
    </div>
  );
};
